import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";
import HomePage from "@/pages/HomePage";
import AgencyPage from "@/pages/AgencyPage";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsAndConditions from "@/pages/TermsAndConditions";
import ScholarshipPage from "@/pages/ScholarshipPage";
import TestPage from "@/pages/TestPage";

const AdminApp = lazy(() => import("@/admin/AdminApp"));
const AgencyAdminApp = lazy(() => import("@/agency-admin/AgencyAdminApp"));

const Loading = () => (
  <div className="min-h-screen bg-navy flex items-center justify-center"><p className="text-slate-400 text-sm">Loading...</p></div>
);

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/agency" element={<AgencyPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/scholarship" element={<ScholarshipPage />} />
          <Route path="/scholarship/test" element={<TestPage />} />
          <Route path="/admin/*" element={<Suspense fallback={<Loading />}><AdminApp /></Suspense>} />
          <Route path="/agency-admin/*" element={<Suspense fallback={<Loading />}><AgencyAdminApp /></Suspense>} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
